export default class MarkPaymentAsCompleted {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, itemId }) {
    this.context.gateways.creditCard.complete({ customerId, itemId });
  }
}
